import NotFoundPage from 'Components/NotFoundPage/NotFoundPage';
import EditorRoute from 'FeatureModules/ProductPage/Components/MultiStep/EditorRoute';
import AnalyticsLayout from 'FeatureModules/ProductPage/Pages/AnalyticsLayout';
import ImpactClaimLayout from 'FeatureModules/ImpactClaim/Pages/ImpactClaimLayout';
import ProductLayout from 'FeatureModules/ProductPage/Pages/ProductLayout';
import SupplyChainLayout from 'FeatureModules/SupplyChain/Pages/SupplyChainLayout';
import ClusterSites from 'FeatureModules/Site/Pages/ClusterSites';
import DataFormatSettings from 'FeatureModules/Setting/Pages/DataFormatSettings';
import PartnerComponentChains from 'FeatureModules/Partner/Pages/PartnerComponentChains';
import PartnerComponentItems from 'FeatureModules/Partner/Pages/PartnerComponentItems';
import PartnerOverview from 'FeatureModules/Partner/Pages/PartnerOverview';
import PartnerSites from 'FeatureModules/Partner/Pages/PartnerSites';
import PlotDocuments from 'FeatureModules/Site/Pages/PlotDocuments';
import PlotOverview from 'FeatureModules/Site/Pages/PlotOverview';
import Plots from 'FeatureModules/Site/Pages/Plots';
import QuestionnaireOverview from 'FeatureModules/Questionnaire/Pages/QuestionnaireOverview';
import QuestionnaireResponses from 'FeatureModules/Questionnaire/Pages/QuestionnaireResponses';
import Questionnaires from 'FeatureModules/Questionnaire/Pages/Questionnaires';
import SiteActivities from 'FeatureModules/Site/Pages/SiteActivities';
import SiteDocuments from 'FeatureModules/Site/Pages/SiteDocuments';
import SiteOverview from 'FeatureModules/Site/Pages/SiteOverview';
import Sites from 'FeatureModules/Site/Pages/Sites';
import Activities from 'FeatureModules/Activity/Pages/Activities';
import ActivityOverview from 'FeatureModules/Activity/Pages/ActivityOverview';
import Can from 'FeatureModules/Auth/Components/Can';
import ComponentsLayout from 'FeatureModules/ComponentChain/Pages/ComponentsLayout';
import ComponentChainMapping from 'FeatureModules/ComponentChain/Pages/ComponentChainMapping';
import ComponentChainOverview from 'FeatureModules/ComponentChain/Pages/ComponentChainOverview';
import ComponentChains from 'FeatureModules/ComponentChain/Pages/ComponentChains';
import ComponentItemOverview from 'FeatureModules/ComponentChain/Pages/ComponentItemOverview';
import ComponentItems from 'FeatureModules/ComponentChain/Pages/ComponentItems';
import DataImportOverview from 'FeatureModules/DataImport/Pages/DataImportOverview';
import DataImports from 'FeatureModules/DataImport/Pages/DataImports';
import DatasetOverview from 'FeatureModules/DataImport/Pages/DatasetOverview';
import DocumentsLayout from 'FeatureModules/Document/Pages/DocumentsLayout';
import PartnerComponentsLayout from 'FeatureModules/Partner/Pages/PartnerComponentsLayout';
import { ImpactClaimStatus } from 'FeatureModules/Request/types/impactClaim.types';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from 'Components/Layout';
import SettingsLayout from 'FeatureModules/Setting/Pages/SettingsLayout';
import DocumentOverview from 'FeatureModules/Document/Pages/DocumentOverview';
import InternalDocuments from 'FeatureModules/Document/Pages/InternalDocuments';
import SharedDocuments from 'FeatureModules/Document/Pages/SharedDocuments';
import ImpactClaimOverview from 'FeatureModules/ImpactClaim/Pages/ImpactClaimOverview';
import ImpactClaims from 'FeatureModules/ImpactClaim/Pages/ImpactClaims';
import MediaLibrary from 'FeatureModules/Media/Pages/MediaLibrary';
import PartnerActivities from 'FeatureModules/Partner/Pages/PartnerActivities';
import PartnerDocuments from 'FeatureModules/Partner/Pages/PartnerDocuments';
import PartnerRequestOverview from 'FeatureModules/Partner/Pages/PartnerRequestOverview';
import Partners from 'FeatureModules/Partner/Pages/Partners';
import FeedbackAnalytics from 'FeatureModules/ProductPage/Pages/FeedbackAnalytics';
import ProductBehaviorAnalytics from 'FeatureModules/ProductPage/Pages/ProductBehaviorAnalytics';
import ProductEditor from 'FeatureModules/ProductPage/Pages/ProductEditor';
import ProductEmbeddedAnalytics from 'FeatureModules/ProductPage/Pages/ProductEmbeddedAnalytics';
import ProductMainAnalytics from 'FeatureModules/ProductPage/Pages/ProductMainAnalytics';
import ProductOverview from 'FeatureModules/ProductPage/Pages/ProductOverview';
import Products from 'FeatureModules/ProductPage/Pages/Products';
import PartnerRequests from 'FeatureModules/Request/Pages/PartnerRequests';
import CompanySettings from 'FeatureModules/Setting/Pages/CompanySettings';
import GoogleAnalyticsTrackingId from 'FeatureModules/Setting/Pages/GoogleAnalyticsTrackingId';
import IntegrationSettings from 'FeatureModules/Setting/Pages/IntegrationSettings';
import NotificationSettings from 'FeatureModules/Setting/Pages/NotificationSettings';
import UserDetails from 'FeatureModules/Setting/Pages/UserDetails';
import UserList from 'FeatureModules/Setting/Pages/UserList';
import SupplyChainMapping from 'FeatureModules/SupplyChain/Pages/SupplyChainMapping';
import SupplyChainOverview from 'FeatureModules/SupplyChain/Pages/SupplyChainOverview';
import SupplyChains from 'FeatureModules/SupplyChain/Pages/SupplyChains';
import SecuritySettings from 'FeatureModules/Setting/Pages/SecuritySettings';
import DesignSettings from 'FeatureModules/Setting/Pages/DesignSettings';
import Home from 'FeatureModules/Home/Pages/Home';

const ClientUIRouter: FC = () => (
  <Routes>
    <Route element={<Layout />}>
      {/* Home */}
      <Route path="/" element={<Home />} />

      {/* Supply chains */}
      <Route element={<SupplyChainLayout />}>
        <Route path="/supply-chains/active" element={<SupplyChains />} />
        <Route path="/supply-chains/archived" element={<SupplyChains isArchived />} />
      </Route>
      <Route path="/supply-chains/active/:productId/:chainId" element={<SupplyChainOverview />} />
      <Route
        path="/supply-chains/active/:productId/:chainId/editor"
        element={<SupplyChainMapping />}
      />

      {/* Components */}
      <Route
        path="/components"
        element={
          <ComponentsLayout selectedTab="components">
            <ComponentItems />
          </ComponentsLayout>
        }
      />
      <Route path="/components/:id" element={<ComponentItemOverview />} />

      {/* Component chains */}
      <Route
        path="/component-chains"
        element={
          <ComponentsLayout selectedTab="component-chains">
            <ComponentChains />
          </ComponentsLayout>
        }
      />
      <Route path="/component-chains/:id" element={<ComponentChainOverview />} />
      <Route path="/component-chains/:id/editor" element={<ComponentChainMapping />} />

      {/* Origin data import */}
      <Route path="/imports" element={<DataImports />} />
      <Route path="/imports/farms" element={<DataImportOverview />} />
      <Route path="/imports/farms/:importId" element={<DataImportOverview />} />
      <Route path="/imports/datasets" element={<DatasetOverview />} />
      <Route path="/imports/datasets/:datasetId" element={<DatasetOverview />} />

      {/* Partners */}
      <Route path="/partners" element={<Partners />} />
      <Route path="/partners/:id" element={<PartnerOverview />} />
      <Route path="/partners/:id/sites" element={<PartnerSites />} />
      <Route path="/partners/:id/documents" element={<PartnerDocuments />} />
      <Route path="/partners/:id/activities" element={<PartnerActivities />} />
      <Route path="/partners/:id/requests" element={<PartnerRequests />} />
      <Route path="/partners/:id/requests/:requestId" element={<PartnerRequestOverview />} />
      <Route
        path="/partners/:id/documents/:documentId"
        element={<DocumentOverview documentType="PARTNER" />}
      />
      <Route path="/partners/:id/imports" element={<DataImports />} />
      <Route path="/partners/:id/imports/farms" element={<DataImportOverview />} />
      <Route path="/partners/:id/imports/farms/:importId" element={<DataImportOverview />} />
      <Route path="/partners/:id/imports/datasets" element={<DatasetOverview />} />
      <Route path="/partners/:id/imports/datasets/:datasetId" element={<DatasetOverview />} />
      <Route
        path="/partners/:id/components"
        element={
          <PartnerComponentsLayout selectedTab="components">
            <PartnerComponentItems />
          </PartnerComponentsLayout>
        }
      />
      <Route
        path="partners/:id/component-chains"
        element={
          <PartnerComponentsLayout selectedTab="component-chains">
            <PartnerComponentChains />
          </PartnerComponentsLayout>
        }
      />

      {/* Activities */}
      <Route path="/activities" element={<Activities />} />
      <Route path="/activities/:id" element={<ActivityOverview />} />

      {/* Sites */}
      <Route path="/sites" element={<Sites />} />
      <Route path="/sites/:id" element={<SiteOverview />} />
      <Route path="/sites/:id/sites" element={<ClusterSites />} />
      <Route path="/sites/:id/documents" element={<Navigate to="internal" />} />
      <Route path="/sites/:id/documents/internal" element={<SiteDocuments />} />
      <Route path="/sites/:id/documents/shared" element={<SiteDocuments />} />
      <Route path="/sites/:id/activities" element={<SiteActivities />} />
      <Route path="/sites/:id/plots" element={<Plots />} />
      <Route path="/sites/:id/plots/:plotId" element={<PlotOverview />} />
      <Route path="/sites/:id/plots/:plotId/documents/internal" element={<PlotDocuments />} />
      <Route path="/sites/:id/plots/:plotId/documents/shared" element={<PlotDocuments />} />
      <Route path="/sites/:id/plots/:plotId/documents" element={<Navigate to="internal" />} />

      {/* Documents */}
      <Route element={<DocumentsLayout />}>
        <Route path="/documents/internal" element={<InternalDocuments />} />
        <Route path="/documents/shared" element={<SharedDocuments />} />
      </Route>
      <Route
        path="/documents/internal/:documentId"
        element={<DocumentOverview documentType="INTERNAL" />}
      />
      <Route
        path="/documents/shared/:documentId"
        element={<DocumentOverview documentType="SHARED" />}
      />

      {/* Questionnaires */}
      <Route path="/questionnaires" element={<Questionnaires />} />
      <Route path="/questionnaires/:questionnaireId" element={<QuestionnaireOverview />} />
      <Route
        path="/questionnaires/:questionnaireId/responses" // Nothing selected the component need to preselect the first available response
        element={<QuestionnaireResponses />}
      />
      <Route
        path="/questionnaires/:questionnaireId/responses/:questionnaireResponseId"
        element={<QuestionnaireResponses />}
      />

      {/* Products */}
      <Route element={<ProductLayout />}>
        <Route path="/products/active" element={<Products />} />
        <Route path="/products/archived" element={<Products isArchived />} />
      </Route>
      <Route path="/products/active/:id" element={<ProductOverview />} />
      <Route
        path="/products/active/:id/editor"
        element={
          <EditorRoute>
            <ProductEditor />
          </EditorRoute>
        }
      />
      <Route element={<AnalyticsLayout />}>
        <Route path="/products/active/:id/analytics" element={<ProductMainAnalytics />} />
        <Route
          path="/products/active/:id/analytics/behavior"
          element={<ProductBehaviorAnalytics />}
        />
        <Route
          path="/products/active/:id/analytics/embedded"
          element={<ProductEmbeddedAnalytics />}
        />
      </Route>
      <Route path="/products/active/:id/feedback" element={<FeedbackAnalytics />} />

      {/* Impact claims */}
      <Route element={<ImpactClaimLayout />}>
        <Route
          path="/impact-claims/active"
          element={<ImpactClaims status={[ImpactClaimStatus.APPROVED]} />}
        />
        <Route
          path="/impact-claims/invalid"
          element={<ImpactClaims status={[ImpactClaimStatus.DENIED]} />}
        />
        <Route
          path="/impact-claims/in-progress"
          element={
            <ImpactClaims
              status={[
                ImpactClaimStatus.CREATED,
                ImpactClaimStatus.REQUESTED,
                ImpactClaimStatus.UPDATED,
              ]}
            />
          }
        />
      </Route>

      <Route path="/impact-claims/active/:id" element={<ImpactClaimOverview />} />

      {/* Media */}
      <Route path="/media-library" element={<MediaLibrary />} />

      {/* Settings */}
      <Route element={<SettingsLayout />}>
        <Route path="/settings" element={<UserDetails />} />
        <Route path="/settings/security" element={<SecuritySettings />} />
        <Route path="/settings/notifications" element={<NotificationSettings />} />
        <Route
          path="/settings/branding"
          element={
            <Can rule="designSettings:access" no={() => <Navigate to="/settings" />}>
              <DesignSettings />
            </Can>
          }
        />
        <Route
          path="/settings/company"
          element={
            <Can rule="companySettings:access" no={() => <Navigate to="/settings" />}>
              <CompanySettings />
            </Can>
          }
        />
        <Route path="/settings/data-format" element={<DataFormatSettings />} />
        <Route
          path="/settings/users"
          element={
            <Can rule="userSettings:access" no={() => <Navigate to="/settings" />}>
              <UserList />
            </Can>
          }
        />
        <Route
          path="/settings/integrations"
          element={
            <Can rule="keys:access" no={() => <Navigate to="/settings" />}>
              <IntegrationSettings />
            </Can>
          }
        />
        <Route
          path="/settings/google-analytics"
          element={
            <Can rule="googleAnalytics:access" no={() => <Navigate to="/settings" />}>
              <GoogleAnalyticsTrackingId />
            </Can>
          }
        />
        {/* Old keys endpoint is still used from inside shopify and woocommerce setup, so we need to redirect it to the new page */}
        <Route path="/settings/keys" element={<Navigate to="/settings/integrations" />} />
      </Route>
    </Route>

    {/* 404 */}
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default ClientUIRouter;
